// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li.selected[data-v-3fc3fe5d]{background-color:var(--primary)}`, "",{"version":3,"sources":["webpack://./ClientApp/components/activitymodal/priorityselectmodal/priorityselectmodal.vue.html"],"names":[],"mappings":"AACA,6BACI,+BAAA","sourcesContent":["\nli.selected {\n    background-color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
